export const accordionData =[
    {
        id:"One",
        qustion:"01. Can I change my package?",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    
    {
        id:"Two",
        qustion:"02. Do packages and prices differ by location or currence?",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    {
        id:"Three",
        qustion:"03. What if I don't want to list my event on eventtbrite and partner sites?",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    {
        id:"Four",
        qustion:"04. What are my payment processing options?",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    {
        id:"Five",
        qustion:'05. What are ticketing and registration "essentials"?',
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    {
        id:"Six",
        qustion:"06. How to create a task when creating a schedule?",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    {
        id:"Seven",
        qustion:"07. How to add membars when making a schedule?",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    {
        id:"Eight",
        qustion:"08. How to add schedule and add reminder?",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    {
        id:"Nine",
        qustion:"09. How to add members when making a schedule",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },
    {
        id:"Ten",
        qustion:"10. How to manage tasks and projects?",
        ans:"Yes! You can change your package at any time. Upgrades will apply immediately to all your live and drafted events, so you can take advantage of professional product capabilities."
    },

]